import * as React from 'react';
import { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TabulatorFull as Tabulator } from "tabulator-tables";
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { Afr, FactTable, getSelectedAfr, getTable } from '../../redux/AfrSlice';
import { loadConcept } from '../../redux/ConceptSlice';
import { setIsDirty } from '../../redux/MiscSlice';
import { ErrorGrid, ErrorSummaryAFRSection, getErrorList, updateSupplementalGridErrors, updateSingleSupplementalGridError, removeSingleSupplementalGridError } from '../../redux/ValidationSlice';
import enums from '../../utils/enums';
import utilityHelper from '../../utils/utilityHelper';
import { ShowSupplementalGridErrorList } from './ShowSupplementalGridErrorList';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import Swal from 'sweetalert2';
import { AdminUserRoleEnum, selectAdminUserRole } from '../../redux/UserSlice';

const RowConceptAndDimensionEditorGrid = (props: {
    tableName: string,
    gridData: any[],
    gridColumns: any[],
    gridOptions: any,
    gridId: string,
}) => {

    /* ************************************** Redux ********************************************/
    const dispatch = useAppDispatch();
    const errorList = useAppSelector(getErrorList);

    /* ************************************** Modal section ************************************/
    const parameters = useLocation();
    const firstFieldId = "FG_001_GeneralFundMember";
    const [modalSubAccountIsOpen, setModalSubAccountIsOpen] = useState(false);
    const [modalAccountIsOpen, setModalAccountIsOpen] = useState(false);
    const [dataRow, setdataRow] = useState({});
    const [fieldToEdit, setFieldToEdit] = useState(firstFieldId);
    const [dataKey, setDataKey] = useState("");
    const [lastErrorValue, setLastErrorValue] = useState<string | null>(null);
    const [lastError, setLastError] = useState<ErrorGrid | null>(null);
    const isDoneRef = useRef(false);
    var tabulatorRef = React.useRef<any>();
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const adminUserRole: AdminUserRoleEnum | null = useAppSelector(selectAdminUserRole);

    const getRateType = function(name: string) : string {
        return name.replace("Special Assessment ", "").replace("Millage ", "");
    }

    /* ***********************************************************************************************************/
    //Events
    /* ***********************************************************************************************************/
    const handleAddRow = function (e: any, rank : number, isRange: boolean, table: any) {

        if (!currentAfr) {
            return;
        }
        var acctTable = getTable(currentAfr, props.tableName);
        if (!acctTable) {
            return;
        }
        var rowDimMap = utilityHelper.generateNewRowDimensionMap(acctTable);

        var account = acctTable.structure.rows[rank];
        var newRow = utilityHelper.createNewRowForTypeDimensionTable(currentAfr, props.tableName, rowDimMap, account);
        var rt = getRateType(account.name);
        if (isRange) {
            rt += " (min/max)";
        } else {
            newRow["MedianMember"] = "0";
        }
        switch (rank) {
            case 0:
                newRow["ratetype"] = rt;
                break;

            case 1:
                newRow["ratetype"] = rt;
                break;
        }
        newRow["isRange"] = isRange;

        table.addRow({ ...newRow }).then(function (rows: any[]) {
            var row = table.getRowFromPosition(table.getRows().length);

            /* save the whole table into misc slice */
            updateCell(null, table);
            showErrors(row);
        }).catch(function (error: any) {
            console.log("we have a problem");
        });
       
    }

    const addRowFromRowFlat = function (e: any, row: any) {
        var table = row.getTable();
        handleAddRow(e, 1, false, table)
    }

    const addRowFromRowFlatRange = function (e: any, row: any) {
        var table = row.getTable();
        handleAddRow(e, 1, true, table)
    }
    const addRowFromRowPercent = function (e: any, row: any) {
        var table = row.getTable();
        handleAddRow(e, 0, false, table)
    }

    const addRowFromRowPercentRange = function (e: any, row: any) {
        var table = row.getTable();
        handleAddRow(e, 0, true, table)
    }

    const addRowFromColumnFlat = function (e: any, column: any) {
        var table = column.getTable();
        handleAddRow(e, 1, false, table)
    }

    const addRowFromColumnFlatRange = function (e: any, column: any) {
        var table = column.getTable();
        handleAddRow(e, 1, true, table)
    }

    const addRowFromColumnPercent = function (e: any, column: any) {
        var table = column.getTable();
        handleAddRow(e, 0, false, table)
    }

    const addRowFromColumnPercentRange = function (e: any, column: any) {
        var table = column.getTable();
        handleAddRow(e, 0, true, table)
    }

    var rowMenu = [
        {
            label: "<i class='bi bi-plus-square-fill'></i> Add Flat Row",
            action: addRowFromRowFlat
        },
        {
            label: "<i class='bi bi-plus-square-fill'></i> Add Percent Row",
            action: addRowFromRowPercent
        },
        {
            label: "<i class='bi bi-plus-square-fill'></i> Add Flat Row (min/max)",
            action: addRowFromRowFlatRange
        },
        {
            label: "<i class='bi bi-plus-square-fill'></i> Add Percent Row (min/max)",
            action: addRowFromRowPercentRange
        },
    ];

    var headerMenu = [
        {
            label: "<i class='bi bi-plus-square-fill'></i> Add Flat Row",
            action: addRowFromColumnFlat
        },
        {
            label: "<i class='bi bi-plus-square-fill'></i> Add Percent Row",
            action: addRowFromColumnPercent
        },
        {
            label: "<i class='bi bi-plus-square-fill'></i> Add Flat Row (min/max)",
            action: addRowFromColumnFlatRange
        },
        {
            label: "<i class='bi bi-plus-square-fill'></i> Add Percent Row (min/max)",
            action: addRowFromColumnPercentRange
        },
    ];


    const handleDelete = function (e: any, cell: any) {

        if (cell && confirm('Are you sure you want to delete this row?')) {

            var table = cell.getTable(); //tabulatorRef.current.table;
            cell.getRow().delete().then(function () {
                var rows : any[] = [];
                rows = table.getData();
                // Turn ON the dirty flag in redux
                dispatch(setIsDirty({ IsDirty: true, Page: "" }));
                // Track the changes on Cells to an array of facts into MiscSlice
                utilityHelper.updateTablePendingFacts(props.tableName, null, table, dispatch);
            }).catch(function (error : any) {

            });


        }

    }

    // show the error from redix misc, this code needs to be adjusted to show the errors depending of the table we are validating
    // the very first version of this code only had into account the projects and bonds tables, so more tables need to be included
    const showErrors = function (row: any) {
        var valid = row.validate();
        var cellsWithError : any[] = [];
        var errors: Array<ErrorGrid> = [];

        if (valid === true) {
            console.log("No Errors");
        } else {
            cellsWithError = valid;
            for (var cellError of cellsWithError) {

                var value = cellError.getValue();
                const { error } = validators(cellError, value, null);
                if (error != null) {
                    errors.push(error);
                }              
            }
        }

        /* remove duplicated errors */

        if (errors.length > 0) {
            var packedErrors: Array<ErrorGrid>;
            packedErrors = utilityHelper.removeDuplicatesFromArray(errors);
            errors = JSON.parse(JSON.stringify(packedErrors));
        }

        dispatch(updateSupplementalGridErrors(errors));

    }
 
    const numberFormatter = function (cell: any) {

        var row = cell.getRow();
        var data = cell.getData();
        var field = cell.getColumn().getField();
        var dataType = getDataType(data.dataType, data.rowConceptId);
        var value = utilityHelper.getNumber(cell.getValue());

        var formatted = utilityHelper.Formatter(cell.getValue(), dataType);
        var element = cell.getElement();
        var isRange = data.isRange;
        switch (field) {
            case "MinimumMember":
            case "MaximumMember":
                if (!isRange) {
                    element.style.backgroundColor = "#696969";
                }
                break;
            case "MedianMember":
                if (isRange) {
                    element.style.backgroundColor = "#696969";
                }
                break;
        }

        return formatted;

    }


    const showErrorIcon = function (cell: any, formatterParams: any, onRendered: any) {
        var text: string = cell.getValue();
        var { section, tab } = utilityHelper.getSectionError(props.tableName);

        if ((typeof text) === "undefined") {
            return text;
        }

        // Verify if there is an error in this section
        var errorSection: ErrorSummaryAFRSection = errorList.find((x: any) => x.section.sectionCode === section);
        if ((typeof errorSection) === "undefined") {
            return text;
        }

        // Discover the array of errors for the section
        var error = errorSection.errorList.find(x => x.entityType === tab && x.entityCode === cell.getData().accountCode);

        if ((typeof error) === "undefined") {
            return text;
        }
        else {
            if (error !== undefined) {
                return "<i class='bi bi-x-octagon-fill text-danger' title='" + error.description + "'></i> " + text;
            }           
        } 
    };


    const validators = function (cell: any, newValue: string, parameters: any) {
        //cell - the cell component for the edited cell
        //value - the new input value of the cell
        //parameters - the parameters passed in with the validator
        var val: string = "";
        var error: ErrorGrid | null = null;
        var row = cell.getRow();
        var fields = "MaximumMember|MedianMember|MinimumMember";
        var rowData: any = row.getData();
        var cId = cell.getField();
        var isRange = rowData.isRange;
        switch (cId) {
            case "MinimumMember":
            case "MaximumMember":
                if (!isRange) {
                    return { result: true, error: null };
                }
                break;
            case "MedianMember":
                if (isRange) {
                    return { result: true, error: null };
                }
                break;
        }

        var fieldMap : any = {};
        for (var s of fields.split("|")) {
            if (rowData.hasOwnProperty(s)) {
                var sval = rowData[s];
                if (sval && sval !== undefined ) {
                    fieldMap[s] = rowData[s];
                }
            }
        }
        var value: string = "";
        if (!(utilityHelper.isNullOrEmpty(newValue))) {
            value = newValue;
          
        }


        /*1 - check if field is required */
        if (value === null || value === "") {
            var isRequired = true;
            if (fields.indexOf(cell.getField()) >= 0) {
                fieldMap[cell.getField()] = newValue;
                switch (cell.getField()) {
                    case "MedianMember":
                        if (fieldMap.hasOwnProperty("MaximumMember") || fieldMap.hasOwnProperty("MinimumMember")) {
                            isRequired = false;
                        }
                        break;
                    case "MinimumMember":
                    case "MaximumMember":
                        if (fieldMap.hasOwnProperty("MedianMember")) {
                            isRequired = false;
                        }
                        break;
                }
            }
            if (isRequired) {
                error = { field: cell.getField(), type: "required", message: enums.rateMemberPublicNames[cell.getField()] + " is required." }
                return { result: false, error };
            }
        } else {
            var isInConflict = false;
            var messagePart = "";
            if (fields.indexOf(cell.getField()) >= 0) {
                fieldMap[cell.getField()] = newValue;
                switch (cell.getField()) {
                    case "MedianMember":
                        if (fieldMap.hasOwnProperty("MaximumMember") || fieldMap.hasOwnProperty("MinimumMember")) {
                            isInConflict = true;
                            messagePart = "Use either a Flat Rate or a range using Minimum and Maximum. You cannot have the Flat Rate, Minimum, and Maximum for one Millage Rate.";
                        }
                        break;
                    case "MinimumMember":
                    case "MaximumMember":
                        if (fieldMap.hasOwnProperty("MedianMember")) {
                            isInConflict = true;
                            messagePart = "Use either a Flat Rate or a range using Minimum and Maximum. You cannot have the Flat Rate, Minimum, and Maximum for one Millage Rate.";
                        }
                        break;
                }
            } 
            if (isInConflict) {
                error = { field: cell.getField(), type: "conflict", message: messagePart }
                return { result: false, error };
            }

        }

        /* 2 - Validate for duplicates rows  */
        var rowDimkey = utilityHelper.getRowDimensionsKey(rowData, cell.getField(), newValue);
        if (utilityHelper.checkForRowDuplicates(cell.getTable(), rowData.key, rowDimkey)) {
            error = { field: "", type: "duplicate", message: rowDimkey + " is duplicated." }
            return { result: false, error };
        }


        /* 3. Rates must be positive numbers  */
        var field: string = cell.getField();

        if (fields.indexOf(field) > 0) {
            if (utilityHelper.getNumber(value) < 0) {
                error = { field: field, type: "negative", message: field + " cannot be negative." }
                return { result: false, error };
            }
        }


        /* 4 - validate ranges  */
        var fields = "MaximumMember|MinimumMember";

        if (fields.indexOf(field) >= 0) {

            var min = row.getData().MinimumMember;
            var max = row.getData().MaximumMember;
            switch (field) {
                case "MinimumMember":
                    min = newValue;
                    break;

                case "MaximumMember":
                    max = newValue;
                    break;

                default:
                    min = "";
                    max = "";
                    break;
            }
            if (!(utilityHelper.isNullOrEmpty(min) || utilityHelper.isNullOrEmpty(max))) {
                if (utilityHelper.getNumber(min) > utilityHelper.getNumber(max)) {
                    error = { field: "MinimumMember", type: "rates", message: "Minimum (" + min + ") cannot be greater than Maximum (" + max + ")." }
                    return { result: false, error };
                }
            }


        }
      
       
        /* ******************************************** */
        return { result: true, error };
    }

    const processEndEditValidations = function (cell: any) {
        var value = cell.getValue();
        const { result, error } = validators(cell, value, null);
        if (!result && error) {
            var modError = { ...error, message: error.message };
            dispatch(updateSingleSupplementalGridError(modError));
            return;
        }
        dispatch(removeSingleSupplementalGridError({ field: "", message: "(editing)" }));
    }

    const handleCancelEdit = function (cell: any) {
        dispatch(removeSingleSupplementalGridError({ field: "", message: "(editing)" }));
    }

    const customValidator = function (cell: any, value: any, parameters: any) {

        const { result, error } = validators(cell, value, parameters);
        if (!result && error) {
            var cellData = cell.getValue();
            if (value !== cellData) {
                var modError = { ...error, message: error.message + " (editing)" };
                dispatch(updateSingleSupplementalGridError(modError));
            }
        }
        return result;
    }


    const showUseRange = function () {
        Swal.fire(
            "Use Rate Range?",
            "If you want to set a minimum and maximum rate range, then delete this row and create a min/max version.",
            'warning'
        );
    }

    const showUseSingle = function () {
        Swal.fire(
            "Use Single Rate?",
            "If you want to set a single rate, then delete this row and create a single rate version.",
            'warning'
        );
    }

    const handleCellClick = function (e: any, cell: any) {

        var row = cell.getRow();

        if (row._row.type != "row") { return }
        var data = cell.getData();
        var isRange = data.isRange;
        setLastErrorValue(null);
        setLastError(null);


        // This is a column-concept table, so the field will be the concept id
        var cId = cell.getField();
        if (cId) {
            switch (cId) {
                case "MinimumMember":
                case "MaximumMember":
                    if (!isRange) {
                        showUseRange();
                        return;
                    }
                    break;
                case "MedianMember":
                    if (isRange) {
                        showUseSingle();
                        return;
                    }
                    break;
            }
            dispatch(loadConcept({
                conceptId: cId,
                taxonomyType: currentAfr ? currentAfr.taxonomyType : TaxonomyTypeEnum.AFR,
                afrYear: currentAfr ? currentAfr.year : 2022
            }));
        }

    }


    const handleRowClick = function (e: any, row: any) {
        //e - the click event object
        //row - row component
        if (row._row.type != "row") { return }
        showErrors(row);
//        row.getTable().deselectRow();
//        row.select();
    }



    // logic to handle the dirty flag in redux store
    const handleEdited = function (cell: any) {

        var newValue: string = cell.getValue();
        //newValue = newValue.trim();

        if ((getValue(cell.getOldValue()) != getValue(newValue)) || (newValue.length > 0 && getValue(newValue) === 0)) {
            // Turn ON the dirty flag in redux
            dispatch(setIsDirty({ IsDirty: true, Page: "" }));
            updateCell(cell, cell.getTable());
        }
        processEndEditValidations(cell);
    }

    const handleIsEditable = function (cell: any) {

        var row = cell.getRow();

        if (row._row.type != "row") { return }
        var data = cell.getData();
        var isRange = data.isRange;



        // This is a column-concept table, so the field will be the concept id
        var cId = cell.getField();
        if (cId) {
            switch (cId) {
                case "MinimumMember":
                case "MaximumMember":
                    if (!isRange) {
                        return false;
                    }
                    break;
                case "MedianMember":
                    if (isRange) {
                        return false;
                    }
                    break;
            }
        }
        return true;
    }
    const updateCell = function (cell: any, table: any) {

        var row: any;
        if (cell) {
            var id: string = cell.getData().id;
            var key = id.split("|")[1].toUpperCase();
            row = cell.getRow();
            row.update({ key: key });
            showErrors(row);
        }

        // Track the changes on Cells to an array of facts into MiscSlice
        utilityHelper.updateTableCell(props.tableName, null, cell, table, dispatch);
        // ***************************************************************************

        if (cell) {
            var row = cell.getRow();
            row.reformat();
        }

    }

    function getKeyByValue(object : any, value : any) {
        return Object.keys(object).find(key => object[key] === value);
    }

    const getDataType = function (dataType: any[], id: string) {

        if ((typeof dataType) === "undefined") {
            return "none";
        }

        var index = dataType.findIndex(x => x.id === id);

        if (index > -1) {
            return dataType[index].dataType;
        }
        return "none";

    }

    const composeSelectFormatter = function (options: any) {

        return (cell: any) => {

            var currentValue = cell.getValue();
            var data = cell.getData();

            if (!currentValue) {
                return currentValue;
            }
            return options[currentValue];
        }
    }
    const showDelete = function (cell: any, formatterParams: any, onRendered: any) {

        return "<i class='bi bi-trash-fill text-danger' title='Click here to delete the row'></i>";

    };

    const showIcons = function (cell: any, formatterParams: any, onRendered: any) {

        var row = cell.getRow();

        var valid = row.validate();

        if (valid === true) {
            return " <i class='bi bi-check-circle-fill text-success'</i>";
        } else {
            return " <i class='bi bi-x-octagon-fill text-danger' title='Click on the row to see all the errors'></i>";
        }


    };



    // ************************************************************* /*
    // General purpose functions                                     //
    // ************************************************************* /*
    // get next row to right to be edited
    const getNextCell = function (cell : any | null) {
        if (!cell) { return "" };
        var cells: any[] = cell.getRow().getCells();
        var found = false;
        for (var c of cells) {
            if (found) { return c.getField() }
            if (c.getField() === cell.getField()) { found = true; }
        }
        return "";
    }


    // Helper to get a cell value
    const getValue = (e: any) => {
        return utilityHelper.getNumber(e);
    }

    const suppressHeaderMenu = (currentAfr: Afr | null) => {
        if (!currentAfr) {
            return true;
        }
        if (utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified)
            || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin) ) {
            return true;
        }

        switch (currentAfr.taxonomyType) {
            case TaxonomyTypeEnum.COURT_REPORTING_939:
                return true;

            default:
                return false;
        }
    }


    // ************************************************************* /*
    // Grid Options                                                  //
    // ************************************************************* /*
    const newGridOptions = {
        layout: "fitColumns",
        layoutColumnsOnNewData: true,
        validationMode: "highlight",
        selectable: 1,
        selectableRollingSelection: false,
        scrollToRowPosition: "center",
        height: "250",  // to be adjusted if another thing is decided
        index: "accountCode",
        cellEditCancelled: handleCancelEdit,
        cellEdited: handleEdited,
        cellClick: handleCellClick,
        ...props.gridOptions

    }

    /* PAINTING THE COLUMNS */
    const defaultColumns : any[] = [];
    var typedDimensionMap: any = {};
    var rowdimFields: string[] = [];
    var conceptFields: string[] = [];

    var isLocked = utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified)
        || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin);
    var showHeaderMenu: boolean = isLocked
    var acctTable: FactTable | null = null;
    if (currentAfr) {
        acctTable = getTable(currentAfr, props.tableName);

        
        if (!isLocked) {
            /* adding the delete button column to the grid */
            defaultColumns.push({
                rowHandle: true, formatter: showDelete, cellClick: handleDelete,
                headerSort: false, frozen: true, width: 30, minWidth: 30, headerContextMenu: suppressHeaderMenu(currentAfr) ? null : headerMenu,
            })
            defaultColumns.push({
                rowHandle: true, formatter: showIcons, headerSort: false,
                frozen: true, width: 32, minWidth: 32, headerContextMenu: suppressHeaderMenu(currentAfr) ? null : headerMenu,
            })
        }

        if (acctTable) {

            /* populate the rate type dropdown */ 
            if (acctTable.structure.rows && acctTable.structure.rows.length > 0) {

                /* populate all the option into the dropdown */
                var options : any = {}

                for (var opc of acctTable.structure.rows) {

                    if (opc.id.toUpperCase().indexOf("TITLE") > 0 ) {
                        continue;
                    }

                    options[opc.id] = opc.name;
                }

                defaultColumns.push(
                    {
                        title: "Rate Type",
                        field: "ratetype",
                        minWidth: 150,
                        maxWidth: 250,
                        headerContextMenu: suppressHeaderMenu(currentAfr) ? null : headerMenu,
                    }
                );

            }


            var primaryAxis: string = acctTable.structure.rowHierarchy.axes[0].id;
            newGridOptions.index = primaryAxis;
            for (var axis of acctTable.structure.rowHierarchy.axes) {
                if (axis.typedDomain) {
                    typedDimensionMap[axis.id] = axis.typedDomain;
                    rowdimFields.push(axis.id + ":" + enums.conceptDatatype[axis.typedDomain.datatype]);
                } else {
                    rowdimFields.push(axis.id);
                }

                if (isLocked) {
                    defaultColumns.push({
                        title: axis.name,
                        field: axis.id,
                        width: 350,
                        formatter: showErrorIcon,
                        frozen: false,
                        headerHozAlign: "center",
                        validator: [{ type: customValidator }],
                    });
                } else {
                    defaultColumns.push({
                        title: axis.name,
                        field: axis.id,
                        editor: "input",
                        editorParams: {
                            search: true,
                            elementAttributes: {
                                maxlength: "2000", //set the maximum character length of the input element to 2000 characters
                            }
                        },
                        formatter: showErrorIcon,
                        frozen: false,
                        headerHozAlign: "center",
                        validator: [{ type: customValidator }],
                        headerContextMenu: suppressHeaderMenu(currentAfr) ? null : headerMenu,
                        cellEditCancelled: handleCancelEdit,
                        cellEdited: handleEdited,
                        cellClick: handleCellClick,
                    });
                }
            }
            // Note - it is possible for the requested account table to not be present in this AFR
            // However that should be deal with upstream so the option doe snot appear
            for (var tbeGroup of acctTable.structure.nthlevelcolumnHierarchy) {
                var t : any | null = null;

                if (tbeGroup.sublevels) {
                    for (var tbeCol of tbeGroup.sublevels) {
                        if (tbeCol.dimensionaspect.member != null) {
                            t = tbeCol.dimensionaspect.member.id;
                            conceptFields.push(t);
                        } else {
                            t = null;
                        }
                       

                        var columnSetting : any | null = null;
                        if (isLocked) {
                            columnSetting = {
                                title: tbeCol.label,
                                field: t,
                                headerSort: false,
                                headerHozAlign: "right",
                                hozAlign: "right",
                                formatter: numberFormatter,
                                formatterParams: {},
                                validator: [{ type: customValidator }],
                                maxWidth: 200
                            };
                        } else {
                            columnSetting = {
                                title: tbeCol.label,
                                field: t,
                                headerSort: false,
                                headerHozAlign: "right",
                                hozAlign: "right",
                                editor: "number",
                                //editorParams: { mask: "999999999999.99" },
                                formatter: numberFormatter,
                                formatterParams: {},
                                validator: [{ type: customValidator }],
                                maxWidth: 200,
                                headerContextMenu: suppressHeaderMenu(currentAfr) ? null : headerMenu,
                                cellEditCancelled: handleCancelEdit,
                                cellEdited: handleEdited,
                                cellClick: handleCellClick,
                                editable: handleIsEditable
                            };
                        }

                        defaultColumns.push(columnSetting);


                    }

                }

            }
        }
    }

    if (defaultColumns.length === 0) {
        defaultColumns.push({
            title: "Name",
            field: "accountCode",
            editor: "input",
            editorParams: {
                search: true,
                elementAttributes: {
                    maxlength: "2000", //set the maximum character length of the input element to 2000 characters
                }
            },
            width: 350,
            formatter: showErrorIcon,
            frozen: false,
            headerHozAlign: "center",
            headerContextMenu: suppressHeaderMenu(currentAfr) ? null : headerMenu,
            cellEditCancelled: handleCancelEdit,
            cellEdited: handleEdited,
            cellClick: handleCellClick,
        });
    }

    var tabledata : any[] = [];
    if (acctTable) {
        var rateDataType : any[] = [];
        for (var opc of acctTable.structure.rows) {

            if (opc.id.toUpperCase().indexOf("TITLE") > 0) {
                continue;
            }
            rateDataType.push({ id: opc.id, dataType: opc.datatype });
        }


        for (var row of acctTable.rows) {
            if (row.facts.length === 0) {
                continue;
            }
            var rowConcept = row.facts[0].concept;
            var conceptId = rowConcept.id;
            var rowdimId = row.dimensions[0].typedContent;
            if (!rowdimId || rowdimId.length === 0) {
                rowdimId = "none";
            }
            var accountLabel = rowdimId;
            var accountId = conceptId;
            var rowid = conceptId + "|" + rowdimId;
            
            var nextRow : any = {
                id: rowid, account: accountLabel, rowConceptId: conceptId, accountId: accountId, accountCode: accountId, dataType: rateDataType,
                dimensionFields: rowdimFields, conceptFields: conceptFields, key: rowdimId.toUpperCase(),
                isRange: false
            }
            nextRow["key"] = utilityHelper.generateGuid(); //key;
            var rowDimMap : any = {};
            for (var drMap of row.dimensions) {
                rowDimMap[drMap.axis.id] = drMap;
            }
            for (var axis of acctTable.structure.rowHierarchy.axes) {
                if (rowDimMap.hasOwnProperty(axis.id)) {
                    var dr = rowDimMap[axis.id];
                    var val = "";
                    if (dr.axis.typedDomain) {
                        // This is a typed member - so get the typedcontent
                        val = dr.typedContent ? dr.typedContent : "";
                    } else {
                        val = dr.member.name;
                    }
                    nextRow[axis.id] = val;
                }
            }
            // Now add the row dimension qualifiers

            /* If any fact exist then it will be linked using the dimension[0].member.id */
            for (var fact of row.facts) {
                nextRow["account"] = fact.concept.id;
                if (fact.concept.id.indexOf("Percent") > 0) {
                    nextRow["ratetype"] = getRateType(acctTable.structure.rows[0].name);
                } else {
                    nextRow["ratetype"] = getRateType(acctTable.structure.rows[1].name);
                }
                for (var drFact of fact.dimensions) {
                    if (drFact.axis.typedDomain) {
                        // These will have been handled by the row dimensions
                        continue;
                    }
                    var colcode = drFact.member ? drFact.member.id : "na";
                    if (rowdimFields.indexOf(colcode) >= 0) {
                        continue;
                    }
                    nextRow[colcode] = fact.value;
                    switch (colcode) {
                        case "MinimumMember":
                        case "MaximumMember":
                            nextRow.isRange = true;
                            nextRow["ratetype"] = nextRow["ratetype"] + " (min/max)";
                            break;
                    }
                }
            }
            tabledata.push(nextRow);

        }

    }
    
    React.useEffect(() => {

        // reset the states when destroying the component
        return function cleanup() {

            // Saving pending changes to AfrSlice
            utilityHelper.saveDeferredChanges(dispatch);

        }
    }, []);

    React.useEffect(() => {

        var emptyErrors: Array<ErrorGrid> = [];

        dispatch(updateSupplementalGridErrors(emptyErrors));

    }, [props]);

    React.useEffect(() => {
        utilityHelper.saveDeferredChanges(dispatch);
        var isLocked = utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified)
            || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin);
        if (isLocked) {
            tabulatorRef.current = new Tabulator("#" + props.gridId, {
                data: tabledata,
                columns: defaultColumns,
                layout: "fitColumns",
                layoutColumnsOnNewData: true,
                selectable: 1,
                selectableRollingSelection: false,
                scrollToRowPosition: "center",
            }).on("rowClick", handleRowClick);

        } else {
            tabulatorRef.current = new Tabulator("#" + props.gridId, {
                data: tabledata,
                columns: defaultColumns,
                layout: "fitColumns",
                layoutColumnsOnNewData: true,
                selectable: 1,
                selectableRollingSelection: false,
                scrollToRowPosition: "center",
                rowContextMenu: rowMenu,
                placeholder: "Right Click The Table Header To Add A New Row",
            }).on("rowClick", handleRowClick);
        }

    }, [props]);

    return (
        <>
            <Row>
                <Col md="12">
                    <Row>
                        <Col>
                            <Row style={{ marginBottom: "1em" }}>
                                <Col>
                                    <div id={props.gridId} ref={ele => { tabulatorRef.current = ele }} />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <ShowSupplementalGridErrorList />
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </Col>
            </Row>

        </>


    );
}


export { RowConceptAndDimensionEditorGrid };
